import React, { useEffect, useRef } from 'react';
import {useMedia} from "react-use";
import {Link} from "react-router-dom";

const BtnOrder = (props) => {
    const isMobile = useMedia("(max-width: 992px)");
    const btnRef = useRef(null);

    const BackgroundColor = {
        cadet: "#36686A",
        white: "#F3F3F3",
        black: "#000000",
        silver: "#E0E9E9"
    }

    useEffect( () => {
        if (props.backgroundColor) {
            btnRef.current.style.background = BackgroundColor[props.backgroundColor];
        }
        if (props.radius) {
            btnRef.current.style.borderRadius = props.radius
        }
    }, []);

    return (
        <div className={`${!isMobile ? 'p-0': ''} btn-order ${props.class ? props.class: ''}`} >
            <Link to={{ pathname: props.link ? props.link: '' }}>
                <button onClick={props.onClick} ref={btnRef} className={`${props.fontSize ? props.fontSize: ''}`}>
                    {props.text}
                </button>
            </Link>
        </div>
    )
}

export default BtnOrder


// WEBPACK FOOTER //
// ./resources/assets/js/flipToFibre/button/BtnOrder.js